import type { DemoCardData, FooterColumn, NavLink } from '@cartcloser/ui/marketing';

/** Public app origin. Production is injected at build time. */
export const APP_URL =
  import.meta.env.VITE_APP_URL ??
  (import.meta.env.DEV ? 'http://localhost:8787' : 'https://app.cc.timgriffin.com');

// Existing clients sign in here; the marketing site doesn't push self-serve
// signup (warm, relationship-led sales — Tim provisions accounts himself).
export const SIGNIN_URL = `${APP_URL}/signin`;

/** Where the contact form delivers. */
export const CONTACT_EMAIL = 'timgriffin@gmail.com';

/** Header nav — only routes that exist. */
export const NAV: NavLink[] = [
  { label: 'How it works', href: '/how-it-works' },
  { label: 'Demos', href: '/demos' },
  { label: 'Sign in', href: SIGNIN_URL },
];

export const FOOTER: FooterColumn[] = [
  {
    title: 'Product',
    links: [
      { label: 'How it works', href: '/how-it-works' },
      { label: 'Live demos', href: '/demos' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Contact', href: '/contact' },
      { label: 'Sign in', href: SIGNIN_URL },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', href: '/privacy' },
      { label: 'Terms', href: '/terms' },
    ],
  },
];

/**
 * Live demo storefronts. Branded "Acme <type>" — never a real client name.
 * `href` points at the mock storefront app (separate; the gallery links out).
 */
export const DEMOS: DemoCardData[] = [
  {
    name: 'Acme Appliances',
    industry: 'Home appliances',
    blurb:
      'Chat with expert agents for dishwashers, fridges, washing machines and dryers. Ask for "a quiet dishwasher for an apartment" and watch it reason over specs.',
    href: '#', // wired to the Acme Appliances storefront when it ships
    status: 'coming-soon',
  },
  {
    name: 'Acme Baby',
    industry: 'Baby products',
    blurb: 'Prams and car seats experts that match safety, fit and lifestyle needs.',
    href: '#',
    status: 'coming-soon',
  },
];
